import React, { useState, useEffect } from "react";

const SelectField = ({
  value,
  options,
  onChange,
  error,
  errorMessage,
  required,
  placeholder,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(0);


  const handleOptionClick = (option) => {
    if (option.value !== null) { 
      onChange({ target: { value: option.value } }); 
      setIsOpen(false);
    }
  };

  const selectedOption = options.find((option) => option.value === value)?.label || placeholder;

  const optionsWithPlaceholder = [
    { value: null, label: placeholder, disabled: true }, 
    ...options, 
  ];


  const handleKeyDown = (event) => {
    if (event.key === "ArrowDown") {
      setHighlightedIndex((prevIndex) => Math.min(prevIndex + 1, optionsWithPlaceholder.length - 1));
    } else if (event.key === "ArrowUp") {
      setHighlightedIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    } else if (event.key === "Enter") {
      const selected = optionsWithPlaceholder[highlightedIndex + 1];
      handleOptionClick(selected);
    }
  };

  useEffect(() => {
    if (isOpen) {
      setHighlightedIndex(0); 
    }
  }, [isOpen]);

  return (
    <div className="flex flex-col gap-1">
      <div className="relative">
        {/* Botón que reemplaza al select */}
        <button
          className={`border-[0.5px] flex items-center h-[40px] w-full justify-between text-gray text-opacity-20 border-[#76A140] border-opacity-50 rounded-md font-itcbook text-[12px]  pl-2 focus:outline-none 
            ${error ? "border-error" : "border-green"
          }
          `}
          onClick={() => setIsOpen(!isOpen)}
          onKeyDown={handleKeyDown}
          tabIndex={0}
        >
          <p className={`${value === "" ? "text-opacity-50 text-gray" : ""} text-black font-itcbook`}>
            {selectedOption}
          </p>
          <div className={`flex items-center justify-center h-full border-l 
            ${error ? "border-error" : "border-green"} border-opacity-50 px-2 ml-2`}>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.76756 6.63501H13.4401C13.7131 6.63501 13.854 6.96697 13.6624 7.16306C13.6621 7.1634 13.6617 7.16374 13.6614 7.16409L11.2565 9.56896L9.779 11.0465C9.35176 11.4737 8.65585 11.4737 8.22861 11.0465L4.34361 7.16146C4.14767 6.96551 4.28682 6.63501 4.56006 6.63501H8.76756Z"
                fill={`${error ? "#EB5757" : "#77A042"}`}
                stroke={`${error ? "#EB5757" : "#77A042"}`}
              />
            </svg>
          </div>
        </button>

        {/* Menú desplegable */}
        {isOpen && (
          <div className="absolute z-10 mt-1 w-full bg-white border rounded-md shadow-lg border-green overflow-y-auto scroll-y-container max-h-[255px]">
            {optionsWithPlaceholder.map((option, index) => (
              <button
                key={option.value}
                onClick={() => handleOptionClick(option)}
                className={`block w-full px-4 py-2 text-[12px] text-left rounded-md font-itcbook
                  ${option.disabled ? "text-gray cursor-default bg-none" : "text-black hover:bg-[#EFEEF7] rounded-none"  } 
                  ${index > 0 && highlightedIndex === index - 1 ? "bg-[#EFEEF7] rounded-none" : ""} // Resaltar solo opciones válidas

                 `}
                 disabled={option.disabled}
                 >
                {option.label}
              </button>
            ))}
          </div>
        )}

        {/* Mensaje de error */}
        {error && (
          <div className="absolute transition-opacity duration-300 left-2 -top-3">
            <div className="p-1 bg-white">
              <p className="text-error font-itcmedium text-[10px]">
                {errorMessage}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectField;